import type { BottomBarItemProps } from '@eliadmin/core/src/components/homepage/bottom-bar';
import type { BadgeProps } from '@eliadmin/core/src/components/ui/badge';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import type { InputProps } from '@eliadmin/core/src/components/ui/input';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { BiSolidCategory } from 'react-icons/bi';
import { FaSuitcaseMedical, FaXTwitter } from 'react-icons/fa6';
import {
  FaFacebook,
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaUser,
  FaYoutube,
} from 'react-icons/fa';
import {
  FiShoppingBag,
  FiHome,
  FiAlignLeft,
  FiHeart,
  FiSettings,
  FiUser,
  FiMenu,
} from 'react-icons/fi';
import {
  RiArrowRightSLine,
  RiFacebookLine,
  RiHourglassLine,
  RiInstagramLine,
  RiLinkedinLine,
  RiMenuFill,
  RiTwitterXLine,
} from 'react-icons/ri';

/** Override this for custom e-shop data, without the need of specific components override */
export const HEADER_CONFIG = {
  bottomBar: {
    items: [
      {
        key: 'categories',
        href: () => ROUTES.CATEGORIES(),
        icon: <BiSolidCategory className="h-5 w-5" />,
        label: 'text176',
      },
      {
        key: 'profile',
        href: () => ROUTES.PROFILE(),
        label: 'text486',
        icon: <FaUser className="h-5 w-5" />,
      },
      {
        key: 'cart',
        href: () => ROUTES.CART(),
        label: 'text343',
        icon: <FiShoppingBag className="h-5 w-5" />,
      },
      {
        key: 'menu',
        isMenu: true,
        icon: <FiMenu className="h-5 w-5" />,
        label: 'Menu',
      },
      {
        key: 'favorites',
        href: () => ROUTES.FAVORITES(),
        label: 'text516',
        icon: <FiHeart className="h-5 w-5" />,
      },
    ] satisfies BottomBarItemProps[],
  },
  searchBar: {
    buttonVariant: 'default' as ButtonProps['variant'],
    inputVariant: 'outlined' as InputProps['variant'],
  },
  headerMain: {
    profile: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <FiUser className="h-5 w-5" />,
    },
    favorites: {
      buttonVariant: 'outline' as ButtonProps['variant'],
      icon: <FiHeart className="h-5 w-5" />,
    },
    contact: {
      icon: <FiSettings className="h-6 w-6 fill-primary" />,
    },
    cart: {
      icon: <FiShoppingBag className="h-6 w-6" />,
      badgeVariant: 'accent' as BadgeProps['variant'],
    },
  },
  categoryButton: {
    icon: <FaSuitcaseMedical className="h-5 w-5" />,
    text: 'Kategórie produktov',
  },
  sidebar: {
    triggerIcon: <RiMenuFill className="h-6 w-6" />,
    menuArrow: <RiArrowRightSLine className="h-6 w-6" />,
    menuItems: [
      {
        key: 'domov',
        title: 'Domov',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.HOME(),
      },
      {
        key: 'profil',
        title: 'Profil',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.HOME(),
      },
      {
        key: 'oblubene',
        title: 'Obľúbené',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.FAVORITES(),
      },
      {
        key: 'kosik',
        title: 'Košík',
        icon: <RiHourglassLine className="h-6 w-6" />,
        href: () => ROUTES.CART(),
      },
    ],
    ctaButtons: [
      {
        variant: 'accent',
        title: 'Call to Action',
        href: '/',
        className: '',
      },
      {
        variant: 'secondary',
        title: 'Action to Call',
        href: '/',
        className: '',
      },
    ],
    icons: [
      {
        key: 'instagram',
        icon: <RiInstagramLine className="h-6 w-6" />,
        href: 'www.instagram.com',
      },
      {
        key: 'facebook',
        icon: <FaFacebookF className="h-6 w-6" />,
        href: 'www.facebook.com',
      },
      {
        key: 'linkedin',
        icon: <RiLinkedinLine className="h-6 w-6" />,
        href: 'www.linkedin.com',
      },
      {
        key: 'twitter',
        icon: <RiTwitterXLine className="h-6 w-6" />,
        href: 'www.twitter.com',
      },
    ],
  },
  socialMediaIcons: {
    facebook: <FaFacebookF fill="black" />,
    instagram: <FaInstagram fill="black" />,
    linkedin: <FaLinkedin fill="#0077B5" />,
    pinterest: <FaPinterest fill="#E60023" />,
    tiktok: <FaTiktok />,
    twitter: <FaXTwitter />,
    youtube: <FaYoutube fill="#FF0000" />,
  } as any,
} as const;
